// import React, { useState, useEffect } from "react";
// import "./Home.css";
// import Navbar from "../../Components/Navbar";
// import Navbar3 from "../../Components/Navbar3";
// import backgroundImage1 from "../../Assets/backgroundImage1.png";
// import backgroundImage2 from "../../Assets/backgroundImage2.png";
// import backgroundImage3 from "../../Assets/backgroundImage3.png";
// import DownloadIcon from "@mui/icons-material/Download";
// import ReactPlayer from 'react-player';

// const Home = () => {
//   const images = [backgroundImage1, backgroundImage2, backgroundImage3];
//   const [currentImage, setCurrentImage] = useState(0);

//   useEffect(() => {
//     const interval = setInterval(() => {
//       setCurrentImage((prevImage) => (prevImage + 1) % images.length);
//     }, 5000);
//     return () => clearInterval(interval);
//   }, [images.length]);

//   return (
//     <div>
//       <Navbar />
//       <Navbar3 />
//       <div className="home-container">
//         <header
//           className="hero-section"
//           style={{
//             backgroundImage: `url(${images[currentImage]})`,
//           }}
//         >
//           <div className="hero-overlay">
//             <h2 className="hero-title">
//               Simplifying the Path to Research Funding and Collaboration
//             </h2>
//             <p className="hero-subtitle">
//               Streamline your grant process, collaborate effectively, and
//               achieve research excellence with ease!
//             </p>
//           </div>
//         </header>

//         <main className="content-section">
//           <section className="features">

//             <h2 className="section-title">Application Guidelines</h2>
//             <div className="feature-cards">
//               <div className="feature-card">
//                 <i className="fas fa-laptop-code feature-icon"></i>
//                 <h3
//                   className="feature-title"

//                 >
//                   Procedure
//                 </h3>
//                 <p>
//                   Grant applications should be submitted online on or before the
//                   deadline specified by the URC.Prepare the following documents before entering the portal:
//                 </p>
//                 <ul>
//                   <li>
//                     Project proposal (as per the template) converted into a PDF <div>
//     <a
//       href="/Templates/Project Proposal.docx"
//       download="Project Proposal.docx"
//       className="template-download-link"
//     >
//       Click Here to Download the Template
//     </a>
//   </div>
//                   </li>
//                   <li>
//                     Project budget (as per the template) converted into a PDF <div>
//     <a
//       href="/Templates/Project Budget.docx"
//       download="Project Budget.docx"
//       className="template-download-link"
//     >
//       Click Here to Download the Template
//     </a>
//   </div>
//                   </li>
//                   <li>
//                     Full CV of the Principal Investigator as a PDF
//                   </li>
//                   <li>
//                     Two-page CVs of all Co-Investigators compiled into a single
//                     PDF
//                   </li>
//                   <li>
//                     DOI of three journal papers or links to conference papers.
//                     For papers without DOI, upload them to Google Drive and
//                     provide the link.
//                   </li>
//                 </ul>
//                 <label className="signup-steps">Steps to Access and Apply for a New Grant</label>
//             <ul style={{ margin: '5px 0', padding: '0 15px' }}>
//             <li>Sign up to the grant management system as a new user, or if you are already registered, log in to the system.</li>
//             <li>You will receive a prompt ‘Welcome, [your name].’ Click OK.</li>
//             <li>Click on the ‘Apply New Grant’ tab and continue.</li>
//             <li className="message">
//            Please wait for the system to display a confirmation message, as it may take some time to upload your data.
//            </li>
//             </ul>

//               </div>

//               <div className="feature-card">
//                 <i className="fas fa-users feature-icon"></i>
//                 <h3
//                   className="feature-title"

//                 >
//                   Detailed Application Instructions Available for Download
//                 </h3>
//                 <div
//                   style={{
//                     display: "flex",
//                     flexDirection: "column",
//                     justifyContent: "center",
//                     alignItems: "center",
//                     margin: "1rem 0",
//                   }}
//                 >
//                   <a
//                     href="/Templates/Application Guidelines.pdf"
//                     download="Application Guidelines.pdf"
//                     style={{
//                       display: "flex",
//                       alignItems: "center",
//                       textDecoration: "none",
//                       color: "#800000",
//                       fontWeight: "bold",
//                     }}
//                   >
//                     <DownloadIcon style={{ fontSize: "2.5rem", color: "#80000", marginRight: "0.5rem" }} />
//                     Application Guidelines.pdf
//                   </a>
//                 </div>
//               </div>

//               <div className="feature-card">
//       <h3 className="feature-title">Application Portal User Guide</h3>

//       <div style={{ display: "flex", justifyContent: "center", marginTop: "1rem" }}>
//         <ReactPlayer
//           url="/video/Application_Portal_Guide.mp4"
//           width="560px"
//           height="315px"
//           controls
//         />
//       </div>
//     </div>

//             </div>
//           </section>
//         </main>
//       </div>
//     </div>
//   );
// };

// export default Home;




import React, { useState, useEffect } from "react";
import "./Home.css";
import Navbar from "../../Components/Navbar";
import Navbar3 from "../../Components/Navbar3";
import backgroundImage1 from "../../Assets/backgroundImage1.png";
import backgroundImage2 from "../../Assets/backgroundImage2.png";
import backgroundImage3 from "../../Assets/backgroundImage3.png";
import DownloadIcon from "@mui/icons-material/Download";
import ReactPlayer from "react-player";
import GuideImage  from "../../Assets/guide.png"; // Assuming you have a guide image
import { API_BASE_URL } from '../../config';

const Home = () => {
  const images = [backgroundImage1, backgroundImage2, backgroundImage3];
  const [currentImage, setCurrentImage] = useState(0);
  const [dates, setDates] = useState({
    Open_Date: "Not Available",
    Close_Date: "Not Available",
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentImage((prevImage) => (prevImage + 1) % images.length);
    }, 5000);

    // Fetch application dates
    const fetchDates = async () => {
      try {
        const response = await fetch(`${API_BASE_URL}/ApplicationDates.php`);
        const data = await response.json();
        if (data.status === "success") {
          setDates({
            Open_Date: data.Open_Date || "Not Available",
            Close_Date: data.Close_Date || "Not Available",
          });
        }
      } catch (error) {
        console.error("Error fetching dates:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchDates();

    return () => clearInterval(interval);
  }, [images.length]);

  return (
    <div>
      <Navbar />
      <Navbar3 />
      <div className="home-container">
        <header
          className="hero-section"
          style={{
            backgroundImage: `url(${images[currentImage]})`,
          }}
        >
          <div className="hero-overlay">
            <h2 className="hero-title">
              Simplifying the Path to Research Funding and Collaboration
            </h2>
            <p className="hero-subtitle">
              Streamline your grant process, collaborate effectively, and
              achieve research excellence with ease!
            </p>
          </div>
        </header>

        <main className="content-section">
          <section className="features">
            {/* New Application Dates Box */}
            <div className="dates-box">
              <div className="dates-content">
                <div className="date-item">
                  <span className="date-label">📅 Application Open Date:</span>
                  <span className="date-value">
                    {loading ? "Loading..." : dates.Open_Date}
                  </span>
                </div>
                <div className="date-item">
                  <span className="date-label">📆 Application Close Date:</span>
                  <span className="date-value">
                    {loading ? "Loading..." : dates.Close_Date}
                  </span>
                </div>
              </div>
            </div>

            <h2 className="section-title">
  <img
    src={GuideImage}
    alt="Guide"
    style={{ width: "40px", height: "40px", objectFit: "contain" }}
  />
  Application Guidelines
</h2>

            <div className="feature-cards">
              <div className="feature-card">
                <i className="fas fa-laptop-code feature-icon"></i>
                <h3 className="feature-title">Procedure</h3>
                <p>
                  Grant applications should be submitted online on or before the
                  deadline specified by the URC.Prepare the following documents
                  before entering the portal:
                </p>
                <ul>
                  <li>
                    Project proposal (as per the template) converted into a PDF{" "}
                    <div>
                      <a
                        href="/Templates/Project_Proposal_MRG.docx"
                        download="Project_Proposal_MRG.docx"
                        className="template-download-link"
                      >
                       Project Proposal Template for MRG Grants
                      </a>
                    </div>
                    <div>
                      <a
                        href="/Templates/Project_Proposal_URG.docx"
                        download="Project_Proposal_URG.docx"
                        className="template-download-link"
                      >
                        Project Proposal Template for URG Grants
                      </a>
                    </div>
                  </li>
                  <li>
                    Project budget (as per the template) converted into a PDF{" "}
                    <div>
                      <a
                        href="/Templates/Project_Budget_MRG.docx"
                        download="Project Budget_MRG.docx"
                        className="template-download-link"
                      >
                        Budget Template for MRG Grants
                      </a>
                    </div>
                    <div>
                      <a
                        href="/Templates/Project_Budget_URG.docx"
                        download="Project_Budget_URG.docx"
                        className="template-download-link"
                      >
                        Budget Template for URG Grants
                      </a>
                    </div>
                  </li>
                  <li>Full CV of the Principal Investigator as a PDF</li>
                  <li>
                    Two-page CVs of all Co-Investigators compiled into a single
                    PDF
                  </li>
                  <li>
                    DOI of three journal papers or links to conference papers.
                    For papers without DOI, upload them to Google Drive and
                    provide the link.
                  </li>
                </ul>
                <label className="signup-steps">
                  Steps to Access and Apply for a New Grant
                </label>
                <ul style={{ margin: "5px 0", padding: "0 15px" }}>
                  <li>
                    Sign up to the grant management system as a new user, or if
                    you are already registered, log in to the system.
                  </li>
                  <li>
                    You will receive a prompt 'Welcome, [your name].' Click OK.
                  </li>
                  <li>Click on the 'Apply New Grant' tab and continue.</li>
                  <li className="message">
                    Please wait for the system to display a confirmation
                    message, as it may take some time to upload your data.
                  </li>
                </ul>
              </div>

              <div className="feature-card">
  <i className="fas fa-users feature-icon"></i>

  <h3 className="feature-title">
    Detailed Application Instructions Available for Download
  </h3>

  <div
    style={{
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      margin: "1rem 0",
      gap: "1rem",
    }}
  >
    {/* URC Guidelines */}
    <a
      href="/Templates/Guideline_and_Application_procedure_URG.pdf"
      download
      style={{
        display: "flex",
        alignItems: "center",
        textDecoration: "none",
        color: "#800000",
        fontWeight: "bold",
      }}
    >
      <DownloadIcon
        style={{
          fontSize: "2.5rem",
          marginRight: "0.5rem",
          color: "#800000",
        }}
      />
      URC Application Guidelines.pdf
    </a>

    {/* MRC Guidelines */}
    <a
      href="/Templates/Guideline_and_Application_procedure_MRG.pdf"
      download
      style={{
        display: "flex",
        alignItems: "center",
        textDecoration: "none",
        color: "#800000",
        fontWeight: "bold",
      }}
    >
      <DownloadIcon
        style={{
          fontSize: "2.5rem",
          marginRight: "0.5rem",
          color: "#800000",
        }}
      />
      MRC Application Guidelines.pdf
    </a>
  </div>
</div>


              <div className="feature-card">
                <h3 className="feature-title">Application Portal User Guide</h3>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    marginTop: "1rem",
                  }}
                >
                  <ReactPlayer
                    url="/video/Application_Portal_Guide.mp4"
                    width="560px"
                    height="315px"
                    controls
                  />
                </div>
              </div>
            </div>
          </section>
        </main>
      </div>
    </div>
  );
};
export default Home;
